module.exports = __webpack_public_path__ + "img/SeQure-white.b7697e6f.svg";